import errorIllustration from './error-illustration.png'

export default errorIllustration
